/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./index.css";

import Loader from "../../../../components/Loader/Index";
import CommonAccountApprovalCard from "../../../../components/_utils/CommonAccountApprovalCard";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import InternalTransactionViewAll from "../../../InternalTransactionMain/InternalTransactionViewAll";
import ScheduleInternalTransactionViewSchedule from "../../../ScheduleInternalTransaction/ScheduleInternalTransactionViewSchedule";
import InternalAccDetail from "../InternalAccountDetail";

import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider";

// Import Redux

import ICONS from "../../../../assets/Icons/index.js";
import InternalAccountPopUp from "../../../../components/Accounts/InternalAccountPopUp/index.jsx";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import {
  addInternalAccLabel,
  removeInternalAccLabel,
} from "../../../../redux/features/InternalAccount/internalAccount";
import {
  beneBankLookUp,
  beneCategories,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  beneInternalDeniedApproval,
  beneInternalRequiredApproval,
  beneInternalWaitingApproved,
  viewInternalAccountDetail,
} from "../../../../redux/features/internalApi/internalApi";
import { internalTxnMultiRejectApproval } from "../../../../redux/features/internalTransaction/internalTransactionSingleApproval";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { schedulesInternalTxnReject } from "../../../../redux/features/scheduleInternalTxn";
import { beneLookUp } from "../../../../redux/features/verifyPAN/verifyPAN";
import accountNameStandardised from "../../../../utils/accountNamestandardised";

const InternalAccountApproval = () => {
  const dispatch = useDispatch();
  const [allAccounts, setAllAccounts] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [InternalAccountid, SetInternalAccountid] = useState(null);
  const [dropdownOptions] = useState([50, 100]);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [isInternalAccountpopUpOpen, SetisInternalAccountpopUpOpen] =
    useState(false);
  const [deniedId, SetdeniedId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [isalertPopup, setAlertPopUp] = useState(false);
  const [pendingNavTarget, setPendingNavTarget] = useState(null);
  const [labelId, setLabelId] = useState([]);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const labelActionDispatchedRef = useRef(false);
  const [showLoader, setShowLoader] = useState(false);
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState({});
  const [declineType, setdeclineType] = useState("");
  const searchBarRefAcc = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const [pageSize, setPageSize] = useState(50);
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [panNumber, setPanNumber] = useState("");
  const [LabelSearchText, setLabelSearchText] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const filterRef = useRef(null);
  const [active, setActive] = useState("");
  const [inputData, setInputData] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const sidebarRef = useRef(null);
  const [isIfsc, setIsIfsc] = useState("");
  const [showRejectPopup, setShowRejectPopup] = useState(false); // show internal transactions to be rejected
  const [accountNumberFilter, setAccountNumberFilter] = useState("");
  const [openInternalAssociate, setOpenInternalAssociate] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [showScheduleTxnPopup, setShowScheduleTxnPopup] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const sidebarButtonRef = useRef(null);
  const [declineReason, setDeclineReason] = useState("");
  const [searchUserText, setSearchUserText] = useState("");
  const dateRef = useRef(null);
  const [associatePopupDate, setAssociatePopupDate] = useState({
    panNumber: "",
    ifscCode: "",
    accNumber: "",
    accId: "",
    accName: "",
  });
  const [associateType, setAssociateType] = useState("");
  const [whichBtnClicked, setWhichBtnClicked] = useState({});

  const [remPan, setRemPan] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [remAccount, setRemAccount] = useState("");
  const [activeType, setActiveType] = useState("pan");

  const updateAllAccounts = (updatedAccounts) => {
    setAllAccounts(updatedAccounts);
  };
  const Navigate = useNavigate();

  const { beneInternalDeniedApprovalLoading } = useSelector(
    (state) => state.internalAcc,
  );

  const {
    schedulesInternalTxnViewAllData,
    schedulesInternalTxnViewAllLoading,
  } = useSelector((state) => state?.scheduleInternalTxnSlice);

  const { internalTxnViewAllAccData, internalTxnViewAllAccLoading } =
    useSelector((state) => state?.internalTxnViewall);

  const { beneInternalWaitingApprovalData } = useSelector((state) => {
    return state.internalAcc;
  });
  const services = useSelector((state) => state.refreshToken.services);

  const handleInputChange = (event) => {
    const value = event.target.value?.replace(/\s+/g, " ").trimStart();

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    if (sanitizedValue.length <= GlobalConfiguration.inputMaxLength) {
      setDeclineReason(sanitizedValue);
    }
  };

  const fetchData = async () => {
    try {
      setAllBeneTxnAccountsLoading(true);

      let queryParams = {
        page_no: page,
        page_size: pageSize,
      };

      if (
        startDateFilter !== "" &&
        endDateFilter !== "" &&
        startDateFilter !== GlobalConfiguration.lengthCheckZero &&
        endDateFilter !== GlobalConfiguration.lengthCheckZero &&
        !isNaN(Number(startDateFilter)) &&
        !isNaN(Number(endDateFilter))
      ) {
        queryParams.start_date = startDateFilter;
        queryParams.end_date = endDateFilter;
      }
      if (accountNumberFilter !== "") {
        queryParams.bank_account_no = accountNumberFilter;
      }

      if (panNumber !== "") {
        queryParams.pan = panNumber;
      }
      if (searchUserText !== "") {
        queryParams.search_string = searchUserText;
      }
      if (LabelSearchText?.length !== GlobalConfiguration.lengthCheckZero) {
        queryParams.labels = LabelSearchText;
      }
      if (isIfsc !== "") {
        queryParams.ifsc = isIfsc;
      }
      const response = await dispatch(
        beneInternalRequiredApproval({
          queryParams,
        }),
      );
      const newData = (response?.payload?.internal_accounts || []).map(
        (account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
        }),
      );

      setAllAccounts(() => [...newData]);
      setMainData(response?.payload);
    } catch (error) {
      console.error("Error fetching internal beneficiary accounts:", error);
    } finally {
      setAllBeneTxnAccountsLoading(false);
    }
  };

  const onMount = () => {
    let availableLabels = sessionStorage?.getItem("AvailableLabelsInternal");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, [
    page,
    pageSize,
    startDateFilter,
    endDateFilter,
    accountNumberFilter,
    panNumber,
    searchUserText,
    isIfsc,
    LabelSearchText,
  ]);

  const handleClose = () => {
    setShowLabelsPopup(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
    fetchData();
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign, recordIdsFromPopup) => {
    setAllBeneTxnAccountsLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(labelId);
    const res = await dispatch(
      addInternalAccLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (addInternalAccLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addInternalAccLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAllBeneTxnAccountsLoading(false);
    if (addInternalAccLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (
    labelsToUnassign,
    recordIdsFromPopup,
  ) => {
    setAllBeneTxnAccountsLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(labelId);
    const res = await dispatch(
      removeInternalAccLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeInternalAccLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeInternalAccLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAllBeneTxnAccountsLoading(false);
    if (removeInternalAccLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const hasAnyFilter =
    Boolean(LabelSearchText?.length) ||
    Boolean(accountNumberFilter?.length) ||
    Boolean(panNumber?.length) ||
    Boolean(searchUserText?.length) ||
    (startDateFilter !== "" &&
      endDateFilter !== "" &&
      startDateFilter !== GlobalConfiguration.lengthCheckZero &&
      endDateFilter !== GlobalConfiguration.lengthCheckZero &&
      !isNaN(Number(startDateFilter)) &&
      !isNaN(Number(endDateFilter))) ||
    Boolean(isIfsc) ||
    Boolean(searchUserTextDebounce?.length);

  const noTransactionsFromAPI =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allBeneTxnAccountsLoading &&
    allAccounts?.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const handleClearFilters = () => {
    setAllBeneTxnAccountsLoading(true);
    setStartDateFilter("");
    setEndDateFilter("");
    setShowSearchBar(false);
    setPanNumber("") || setAccountNumberFilter("");
    setIsIfsc("") || setLabelSearchText("");
    setSearchUserTextDebounce("");
    setSearchUserText("");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        !(dateRef.current && dateRef.current.contains(event.target))
      ) {
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }

      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        sidebarButtonRef.current &&
        !sidebarButtonRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const updateIsFilterApplied = () => {};

  useEffect(() => {
    updateIsFilterApplied();
  }, [startDateFilter, endDateFilter]);

  const openTxnPopup = (id, acc_Name) => {
    setAssociatePopupDate((prev) => {
      return {
        ...prev,
        accId: id,
        accName: acc_Name,
      };
    });
  };

  const openAssociatedAccountsFound = (ifsc_code, acc_no, pan_no, id) => {
    dispatch(beneLookUp({ pan_number: pan_no }));
    dispatch(
      beneBankLookUp({
        ifsc: ifsc_code,
        bank_account_no: acc_no,
      }),
    );
    setAssociatePopupDate((prev) => {
      return {
        ...prev,
        ifscCode: ifsc_code,
        accNumber: acc_no,
        accId: id,
        panNumber: pan_no,
      };
    });
    setRemPan(pan_no);
    setOpenInternalAssociate(true);
  };

  useEffect(() => {
    let availableLabels = sessionStorage?.getItem("AvailableLabelsInternal");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, []);

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setDeclineReason("");
  };

  // Internal Txn & Schedule internal txn check
  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setShowLoader(true);
    setShowPopup(false);

    const accountInfo = await dispatch(
      viewInternalAccountDetail({ id: deniedId }),
    );
    if (
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_internal_transactions === "Y" &&
      (accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_scheduled_internal_transactions === "Y" ||
        accountInfo?.payload?.internal_accounts?.[0]
          ?.pending_scheduled_internal_transactions === "N")
    ) {
      setShowRejectPopup(true);
    } else if (
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_internal_transactions === "N" &&
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_scheduled_internal_transactions === "Y"
    ) {
      setShowScheduleTxnPopup(true);
    } else {
      handleInternalAccountreject(id, AccountIdData);
    }
  };

  const handleInternalAccountreject = async (id, AccountIdData) => {
    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    if (
      !beneInternalDeniedApprovalLoading ||
      beneInternalDeniedApprovalLoading === null
    ) {
      const data = await dispatch(
        beneInternalDeniedApproval({ id, AccountIdData }),
      );

      if (
        data?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration.lengthCheckZero
      ) {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "IAAccount",
          },
        });
        return;
      }

      setShowLoader(true);
      // SetCancleButtonHide(false);
      await new Promise((resolve) => {
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
      });

      if (data?.payload?.status === false) {
        let error_msg = "";
        if (data?.payload?.errors?.internal_account?.[0]) {
          error_msg = data?.payload?.errors?.internal_account[0];
        } else if (data?.payload?.errors?.bank_account_number?.[0]) {
          error_msg = data?.payload?.errors?.bank_account_number[0];
        } else {
          error_msg = "An unknown error occurred.";
        }
        const updatedData = allAccounts?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "error" : "pending",
              rejected_on:
                data.payload.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_on
                  : "",
              rejected_by_name:
                data.payload.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_by_name
                  : "",
              rejection_reason: AccountIdData,
              error:
                item.error === "false" && data?.payload?.status === false
                  ? "true"
                  : "false",
              message: data?.payload?.status === false ? error_msg : "",
              pending_internal_transactions:
                associateType === "rejectAccount" ? "N" : "Y",
              pending_scheduled_internal_transactions:
                associateType === "rejectAccount" ? "N" : "Y",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);
        setShowPopup(false);
        setShowLoader(false);
        setDeclineReason("");
        setShowRejectPopup(false);

        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        const updatedData = allAccounts.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "rejected" : "pending",

              rejected_on:
                data?.payload?.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_on
                  : "",
              rejected_by_name:
                data?.payload?.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_by_name
                  : "",
              rejection_reason: AccountIdData,
              error:
                item?.error === "false" && data?.payload?.status === false
                  ? "true"
                  : "false",
              message:
                item?.message === "" && data?.payload?.status === false
                  ? data?.payload?.errors?.internal_accounts[0]
                  : "",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);
        setShowLoader(false);
        setDeclineReason("");
        setShowRejectPopup(false);
        if (data?.payload?.status === true) {
          CommonToast({
            text: "Account rejected successfully.",
            icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
        setShowPopup(false);
      }
    }
  };

  const handleApprovalToastSuccess = () => {
    toast.dismiss();
    CommonToast({
      text: "Account approved successfully.",
      icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
      variant: "var(--success)",
      btnProps: {
        isDisabled: false,
        enabledTextColor: "var(--text-primary)",
        enabledBgColor: "var(--primary-bg)",
      },
    });
  };

  // Reject internal transaction
  const handleConfirmAlert = async (transactions) => {
    setShowPopup(false);
    try {
      const AccountIdData = declineReason;
      let all_txn_id = [];
      all_txn_id =
        !internalTxnViewAllAccLoading &&
        internalTxnViewAllAccData?.transactions?.length >
          GlobalConfiguration.lengthCheckZero
          ? internalTxnViewAllAccData?.transactions.map((data) => {
              return data?.txn_id;
            })
          : [];

      UniversalRefreshToast("Rejecting transaction");

      let data = null;

      if (all_txn_id.length > GlobalConfiguration.lengthCheckZero) {
        data = await dispatch(
          internalTxnMultiRejectApproval({ id: all_txn_id, AccountIdData }),
        );
      }

      if (data?.payload?.status === false) {
        setShowRejectPopup(false);
        const error_msg = data?.payload?.errors?.user_unauthorized
          ? data?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data?.payload?.errors?.base) &&
              Array.isArray(data?.payload?.errors?.base[0]?.errors)
            ? data.payload.errors.base[0].errors[0]
            : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setShowLoader(false);
      } else if (data?.payload?.status === true) {
        setShowRejectPopup(false);
        setTimeout(() => {
          toast.dismiss();
          CommonToast({
            text: "Transaction rejected successfully.",
            icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }, 2000);
        const updatedData = allAccounts?.map((item) => {
          if (item.id === associatePopupDate?.accId) {
            return {
              ...item,
              pending_internal_transactions: "N",
            };
          }
          return item;
        });

        if (associateType === "rejectAccount") {
          allAccounts?.forEach((item) => {
            if (item.id === associatePopupDate?.accId) {
              if (item?.pending_scheduled_internal_transactions === "Y") {
                setTimeout(() => {
                  setShowScheduleTxnPopup(true);
                }, IntervalConfiguration.intervalMedium);
              } else {
                handleInternalAccountreject(
                  associatePopupDate?.accId,
                  declineReason,
                );
              }
            }
          });
        }
        updateAllAccounts(updatedData);
      } else if (data?.payload === undefined) {
        setShowRejectPopup(false);

        CommonToast({
          text: "An error occurred while taking action on this account",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
      setShowLoader(false);

      if (associateType === "InternalTxn") {
        setDeclineReason("");
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong. Please try again",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
  };

  const handleApproval = async (id) => {
    setWhichBtnClicked((p) => {
      return {
        ...p,
        [id]: "approve",
      };
    });
    setLoading((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true,
    }));
    UniversalRefreshToast("approvalaccountsRefresh");

    const data = await dispatch(beneInternalWaitingApproved(id));

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "IAAccount",
        },
      });
      return;
    }

    let errorMessage = "";
    if (data) {
      const errors = data?.payload?.errors;
      if (errors?.internal_account?.[0]) {
        errorMessage = errors.internal_account[0];
      } else if (errors?.bank_account_number?.[0]) {
        errorMessage = errors.bank_account_number[0];
      } else {
        errorMessage = "An unknown error occurred.";
      }
    }

    if (data) {
      const updatedData = allAccounts.map((item) => {
        if (item.id === id) {
          let lifecycleStatus = "";

          if (data.payload.status === true) {
            lifecycleStatus = "Approved";
          }
          if (data.payload.status === false) {
            lifecycleStatus = "error";
          }

          let message = "";
          if (data.payload.status === false) {
            const errors = data?.payload?.errors;
            if (errors?.internal_account?.[0]) {
              message = errors.internal_account[0];
            } else if (errors?.bank_account_number?.[0]) {
              message = errors.bank_account_number[0];
            }
          }

          return {
            ...item,
            approval_status:
              item.approval_status === "pending" ? lifecycleStatus : "pending",
            error:
              item.error === "false" && data?.payload.status === false
                ? "true"
                : "false",
            message:
              item.message === "" && data.payload.status === false
                ? message
                : "",
          };
        }

        return item;
      });

      setAllAccounts(updatedData);

      if (data?.payload.status === false) {
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    }

    setTimeout(() => {
      setLoading((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false,
      }));
    }, 2000);

    setTimeout(() => {
      if (data.payload.status === true) {
        handleApprovalToastSuccess();
      }
    }, 2000);
  };

  const InternalAccountDetailsPopUp = async (id) => {
    SetInternalAccountid(id);
    SetisInternalAccountpopUpOpen(!isInternalAccountpopUpOpen);
  };
  const closeBeneAccountDetailModal = () => {
    SetisInternalAccountpopUpOpen(false);
  };

  const fetchData2 = async () => {
    let response;
    let data = [];
    setLoadingData(true);

    switch (active) {
      case "Category":
        response = await dispatch(
          beneCategories({ search_string: searchUserTextDebounce }),
        );
        data = response?.payload?.categories?.map((itm) => {
          return {
            id: itm.name,
            Category: itm.name,
            Description: itm?.description || "Not given",
          };
        });
        setInputData(data);
        setLoadingData(false);
        break;
      case "Labels":
        data = labels
          ?.filter((itm) => {
            return itm.includes(searchUserTextDebounce);
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchData2();
    }
  }, [active]);

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setPage(Number(page));
    toggleDropdown();
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handlePagination = (page) => {
    setPage(page);
  };

  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(convertDate(start));
      setEndDateFilter(convertDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );
    return timestamp;
  };

  // Reject Schedule beneficiary transactions
  const handleRejectScheduleInternalTxn = async () => {
    let id2 =
      !schedulesInternalTxnViewAllLoading &&
      schedulesInternalTxnViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? schedulesInternalTxnViewAllData?.transactions.map(
            (data) => data?.txn_id,
          )
        : [];
    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      let data2 = await dispatch(
        schedulesInternalTxnReject({
          id: id2,
          type: "scheduleInternalTxn",
          reason: declineReason,
          services,
        }),
      );
      if (data2?.payload?.status === false) {
        const error_msg2 = data2?.payload?.errors?.user_unauthorized
          ? data2?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data2?.payload?.errors?.base) &&
              Array.isArray(data2?.payload?.errors?.base[0]?.errors)
            ? data2.payload.errors.base[0].errors[0]
            : data2?.payload?.errors?.base?.[0] || "Unknown error occurred";

        CommonToast({
          text: error_msg2,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setTimeout(() => {
          setShowScheduleTxnPopup(false);
        }, IntervalConfiguration.intervalMedium);

        setShowLoader(false);
      } else if (data2?.payload?.status === true) {
        setShowScheduleTxnPopup(false);
        toast.dismiss();
        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setTimeout(() => {
          setShowScheduleTxnPopup(false);
        }, IntervalConfiguration.intervalMedium);

        const updatedData = allAccounts?.map((item) => {
          if (item.id === associatePopupDate?.accId) {
            return {
              ...item,
              pending_scheduled_internal_transactions: "N",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);

        if (associateType === "rejectAccount") {
          handleInternalAccountreject(deniedId, declineReason);
        }
      }
      setDeclineReason("");
      setAssociateType("");
      setShowPopup(false);
    }
  };

  const handleCardClick = (targetPath) => {
    setPendingNavTarget(targetPath);
    setAlertPopUp(true);
  };

  const handleLeaveConfirm = () => {
    setAlertPopUp(false);
    if (pendingNavTarget) {
      navigate(pendingNavTarget);
    }
    setPendingNavTarget(null);
  };

  const handleAlertCancel = () => {
    setAlertPopUp(false);
    setPendingNavTarget(null);
  };

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <>
      {isalertPopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle="Open in full view?"
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext="Leaving this page will exit you from current flow."
            btnOneText="Cancel"
            btnOneHandleFunction={handleAlertCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoHandleFunction={handleLeaveConfirm}
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {/* Popup for entering reason for declining account & transaction */}
      {showPopup && (
        <div
          className={`fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity`}
        >
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the account."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            inputPlaceholder="Reason (10-150 char)"
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnTwoInActiveVariantNeeded={true}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (showLoader) return;
              handleInputChange(e);
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            // End of Input Field Props
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              if (!showLoader) {
                setWhichBtnClicked((p) => {
                  return {
                    ...p,
                    [deniedId]: "none",
                  };
                });
                handleClosePopup();
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (showLoader) return;
              setShowPopup(false);
              if (associateType === "scheduleInternalTxn") {
                handleRejectScheduleInternalTxn();
              } else if (associateType === "InternalTxn") {
                handleConfirmAlert();
              } else {
                handleRejectTransactionChecker(deniedId, declineReason);
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.panLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {/* Display associate account */}
      {openInternalAssociate && (
        <InternalAccountPopUp
          accountType="internal"
          associateAccount={true}
          associatepanNumber={associatePopupDate.panNumber}
          IFSC={associatePopupDate.ifscCode}
          accountNumber={associatePopupDate.accNumber}
          onClosepop={() => {
            setOpenInternalAssociate(false);
            setRemPan("");
            setRemAccount("");
            setRemIFSC("");
            setActiveType("pan");
          }}
          ispanbankRequired={true}
          associateIFSC={associatePopupDate.ifscCode}
          associateaccountNumber={associatePopupDate.accNumber}
          setOpenInternalAssociate={setOpenInternalAssociate}
          setOpenBeneAssociate={(e) => {}}
          activeType={activeType}
          setActiveType={setActiveType}
          setRemPan={setRemPan}
          setRemAccount={setRemAccount}
          setRemIFSC={setRemIFSC}
          remPan={remPan}
          remAccount={remAccount}
          remIFSC={remIFSC}
          beneAccountId={associatePopupDate.accId}
          typePanBank={"BeneAccPanBankSwitch"}
          onCardNavigate={handleCardClick}
        />
      )}

      {/* Reject internal transactions */}
      {showRejectPopup && (
        <LargePopupRedirect
          headerTitle="Associated transactions found"
          headersubtext="The following transactions are linked and need to be rejected before rejecting this account."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => {
            setShowRejectPopup(false);
            setShowPopup(false);
            setWhichBtnClicked((p) => {
              return {
                ...p,
                [deniedId]: "none",
              };
            });
          }}
          closeicon={"https://q2pay.in/new_assets/common/create_flow/close.svg"}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          bottomHeaderTextNeed={true}
          bottomHeaderText={
            "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
          }
          isbottomSectionneed={true}
          btnText={"Reject all"}
          confirmbtnrequired={true}
          handleFunction={() => {
            const servicesReq = ["AInternalTxn"];

            if (servicesReq.some((service) => services.includes(service))) {
              if (associateType === "InternalTxn") {
                setShowPopup(true);
              } else {
                handleConfirmAlert();
              }
            }
          }}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={showInnerSearchBar || isSidebarOpen ? true : false}
          disabledTextColor={""}
          disabledBgColor={""}
        >
          <InternalTransactionViewAll
            // typepop={"RejectAllTransactionPopup"}
            typepop={"RejectInternalAcc"}
            type={
              declineType === "rejectedAccount"
                ? "Internal_AccountApproval"
                : "RejectInternalTxn"
            }
            internal_acc_id={associatePopupDate?.accId}
            bank_acc_no={associatePopupDate?.accNumber}
            closeRejectAllTxn={() => {
              setShowRejectPopup(false);
              setShowPopup(false);
              setWhichBtnClicked((p) => {
                return {
                  ...p,
                  [deniedId]: "none",
                };
              });
            }}
            // handleRejectAllTransaction={
            //   declineType === "rejectedAccount"
            //     ? handleRejectAllTransaction
            //     : handleCloseInternalReject
            // }
            setShowLoader={setShowLoader}
            setSidebarState={(e) => {}}
            setFocus={(e) => {}}
          />
        </LargePopupRedirect>
      )}

      {/* Reject schedule internal transactions */}
      {showScheduleTxnPopup && (
        <LargePopupRedirect
          headerTitle="Associated schedules found"
          headersubtext="The following schedules are linked and need to be rejected before rejecting this account."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => setShowScheduleTxnPopup(false)}
          closeicon={"https://q2pay.in/new_assets/common/create_flow/close.svg"}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          bottomHeaderTextNeed={true}
          bottomHeaderText={
            "To reject the account, please reject the schedules listed above by clicking the “Reject all” button. The schedules will get rejected with the provided rejected reason."
          }
          isbottomSectionneed={true}
          btnText={"Reject all"}
          confirmbtnrequired={true}
          handleFunction={() => {
            if (associateType === "scheduleInternalTxn") {
              setShowPopup(true);
            } else {
              handleRejectScheduleInternalTxn();
            }
          }}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={false}
          disabledTextColor={""}
          disabledBgColor={""}
        >
          <ScheduleInternalTransactionViewSchedule
            type={"scheduleInternalAcc"}
            txnHistorytype={"scheduleInternalAccApproval"}
            internal_account_id={associatePopupDate?.accId}
            closeCallback={handleClosePopup}
          />
        </LargePopupRedirect>
      )}

      {/* Label popup */}
      {showLabelsPopup && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowLabelsPopup(true);
          }}
          className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={[labelId].filter(Boolean)}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={(allAccounts || [])
              ?.filter((acc) => acc?.id === labelId)
              ?.map((acc) => ({ ...acc, id: acc.id }))}
            onClose={handleClose}
            loading={allBeneTxnAccountsLoading}
            setLoading={setAllBeneTxnAccountsLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}

      {/* Show Internal Account in modal */}
      {isInternalAccountpopUpOpen && (
        <LargePopupRedirect
          headerTitle="Internal account details"
          closeiconhandleFunction={() => closeBeneAccountDetailModal()}
          isfullViewrequired={true}
          isscrollRequired={true}
          fullviewhandleFunction={() => {
            navigate(
              `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${InternalAccountid}`,
            );
          }}
        >
          <InternalAccDetail
            bene_account_id={InternalAccountid}
            onAccountUpdated={fetchData}
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            type={"bene_account_detail_modal"}
            servicesType="BenAdmin"
          />
        </LargePopupRedirect>
      )}

      {/* Entire page */}
      <div className={` h-screen overflow-hidden flex flex-col`}>
        <div className=" relative z-z-index-overlay bg-primary-nav min-h-0 Qmd:min-h-navbar-breadcrumb-height">
          {" "}
        </div>
        <div className="w-full relative z-z-index-overlay lg:px-padding-base  flex items-center justify-end m-auto ">
          <TopNavComponent
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: isSidebarOpen || allBeneTxnAccountsLoading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search internal account",
              filterPlaceholder:
                "name / contact number / email ID / account ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: setSearchUserText,
                  isDropdown: false,
                  isDisabled: false,
                },
                {
                  name: "Account number",
                  short_name: "Internal. Acc",
                  isMulti: false,
                  value: accountNumberFilter,
                  setValue: setAccountNumberFilter,
                  isDropdown: false,
                  valueType: "string",
                  isDisabled: allBeneTxnAccountsLoading ? true : false,
                },
                {
                  name: "IFSC code",
                  short_name: "IFSC",
                  isMulti: false,
                  value: isIfsc.toUpperCase(),
                  setValue: setIsIfsc,
                  valueType: "string",
                  isDropdown: false,
                  isDisabled: allBeneTxnAccountsLoading ? true : false,
                },
                {
                  name: "PAN number",
                  short_name: "PAN",
                  isMulti: false,
                  value: panNumber.toUpperCase(),
                  setValue: setPanNumber,
                  valueType: "string",
                  isDropdown: false,
                  isDisabled: allBeneTxnAccountsLoading ? true : false,
                },

                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: setLabelSearchText,
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: allBeneTxnAccountsLoading,
                },
              ],
              filters: [
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => handleDateChange(date),
                },
              ],
              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                loading
              ),
              isSearchClearAllDisabled: !(
                panNumber !== "" ||
                LabelSearchText?.length !==
                  GlobalConfiguration.lengthCheckZero ||
                isIfsc !== "" ||
                accountNumberFilter !== "" ||
                searchUserText !== ""
              ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loadingData: loadingData,
              loading: allBeneTxnAccountsLoading,
              setLoading: setLoadingData,
              isShowFilter: true,

              // isSortDisabled: setAllBeneTxnAccountsLoading,
              isFilterDisabled: allBeneTxnAccountsLoading,
            }}
          />
        </div>
        {isSidebarOpen ||
          (showInnerSearchBar && <div className="acc_black_div "></div>)}
        <div
          id="viewAllScrollContainerBar"
          className={` ${(isSidebarOpen || showInnerSearchBar) && " bg-PopUp-BackDrop opacity-light-opacity flex flex-col items-center pointer-events-none overflow-hidden "} h-height-full overflow-hidden !pb-padding-base`}
        >
          {allBeneTxnAccountsLoading ? (
            <div className="loader-container m-auto justify-center items-center flex">
              <Loader />
            </div>
          ) : noResultsAfterFilter ? (
            <div className="flex flex-col items-center justify-center m-auto w-full h-full">
              <img
                src={
                  "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                }
                alt="No accounts found"
                className={"w-graphic-width-md h-graphic-rectangle-height-md"}
              />
              <p className="bene-acc-no-beneaccount-text my-margin-sm">
                No data found.
              </p>

              <PrimaryButton
                enabledBgColor="var(--primary-nav-act)"
                btnText="Clear parameters"
                btnType="button"
                handleFunction={handleClearFilters}
                hoverOption="white"
                enabledTextColor="var(--text-primary)"
              />
            </div>
          ) : allAccounts?.length > GlobalConfiguration.lengthCheckZero ? (
            <div className="w-width-full overflow-auto h-full">
              <div
                className={`scroll flex flex-col items-center ${(isSidebarOpen || showInnerSearchBar) && "opacity-dark-opacity"} justify-center w-full overflow-y-auto   `}
                ref={filterRef}
              >
                <div
                  className={`scroll flex flex-col items-center lg:w-max-content-width gap-gap-md w-width-full mb-margin-md px-padding-md lg:px-padding-base ${(isSidebarOpen || showInnerSearchBar) && "opacity-dark-opacity"} h-height-full justify-start`}
                >
                  {allAccounts?.map((account, index) => {
                    // const asAcc = alertInfo?.alertData?.asAcc;

                    // const pendingTxn = alertInfo?.alertData?.pendingTxn;

                    // Associated account based on PAN or Bank
                    const asAcc =
                      account?.associate_bank === "Y" ||
                      account?.associate_pan === "Y";

                    // Pending transaction for the account
                    const pendingTxn = account?.pending_internal_transactions;

                    // Pending schedule transaction for the account
                    const pendingScheduleTxn =
                      account?.pending_scheduled_internal_transactions;

                    const buildAlerts = () => [
                      ...(asAcc !== undefined
                        ? asAcc
                          ? [
                              {
                                isLoading: false,
                                text: "Associated accounts are found",
                                icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
                                onClick: () => {
                                  setRemPan(account.pan_no);
                                  openAssociatedAccountsFound(
                                    account?.ifsc_code,
                                    account?.bank_acc_no,
                                    account?.pan_no,
                                    account?.id,
                                  );
                                },
                              },
                            ]
                          : []
                        : [
                            {
                              isLoading: true,
                              text: "Checking associated account",
                            },
                          ]),

                      ...(pendingTxn !== undefined
                        ? pendingTxn === "Y"
                          ? [
                              {
                                isLoading: false,
                                text: "Pending transactions found",
                                icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
                                onClick: () => {
                                  openTxnPopup(account?.id, account?.name);
                                  setdeclineType("");
                                  setShowRejectPopup(true);
                                  setAssociateType("InternalTxn");
                                  setAssociatePopupDate((prev) => {
                                    return {
                                      ...prev,
                                      accNumber: account?.bank_acc_no,
                                    };
                                  });
                                },
                              },
                            ]
                          : []
                        : [
                            {
                              isLoading: true,
                              text: "Checking pending transactions",
                            },
                          ]),

                      ...(pendingScheduleTxn !== undefined
                        ? pendingScheduleTxn === "Y"
                          ? [
                              {
                                isLoading: false,
                                text: "Pending schedules found",
                                icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
                                onClick: () => {
                                  // setTypePending("pending");
                                  openTxnPopup(account?.id, account?.name);
                                  setShowScheduleTxnPopup(true);
                                  setAssociateType("scheduleInternalTxn");
                                },
                              },
                            ]
                          : []
                        : [
                            {
                              isLoading: true,
                              text: "Checking schedule pending transactions",
                            },
                          ]),
                    ];

                    return (
                      <div
                        key={account.id}
                        className={`w-full ${index === GlobalConfiguration.lengthCheckZero ? "mt-margin-md" : ""}`}
                      >
                        <CommonAccountApprovalCard
                          overrideAutoLoader
                          whichBtnClicked={
                            whichBtnClicked?.[account.id] ?? "none"
                          }
                          entries={[
                            [
                              {
                                type: "textSubtext",

                                text: accountNameStandardised(account.name),

                                subText: "Account name",
                              },

                              {
                                type: "textSubtext",

                                text: account.email_id,

                                subText: "Email ID",
                              },

                              {
                                type: "textSubtext",

                                text: "+91 " + account.contact_no,

                                subText: "Contact number",
                              },

                              {
                                type: "textSubtext",

                                text: account.account_type,

                                subText: "Account",
                              },
                            ],

                            [
                              {
                                type: "textSubtext",

                                text: account.bank_account_holder_full_name,

                                subText: "Bank account holder name ",
                              },

                              {
                                type: "accountNumber",

                                text: account.bank_acc_no,

                                subText: "Account number",

                                ifsc: account.ifsc_code,
                              },

                              {
                                type: "textSubtext",

                                text: account.ifsc_code,

                                subText: "IFSC code",
                              },

                              {
                                type: "textSubtextX2",

                                text: account.pan_no,

                                subText: "PAN number",

                                text1: account.gstin_detail || "Not given",

                                subText1: "GSTIN",
                              },
                            ],

                            [
                              {
                                type: "cta",

                                text:
                                  account?.labels?.join(", ") ||
                                  "No labels assigned",

                                subText: "Labels",

                                onClick: (e) => {
                                  if (
                                    services?.includes("ALabel") &&
                                    services?.includes("RLabel")
                                  ) {
                                    e.stopPropagation();
                                    setLabelId(account?.id);
                                    setShowLabelsPopup(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "ALabel,RLabel",
                                      },
                                    });
                                  }
                                },
                              },
                            ],
                          ]}
                          approveClick={() => handleApproval(account.id)}
                          rejectClick={() => {
                            setWhichBtnClicked((p) => {
                              return {
                                ...p,
                                [account?.id]: "reject",
                              };
                            });
                            handleOpenPopup(account?.id);
                            setdeclineType("rejectedAccount");
                            setAssociatePopupDate((prev) => {
                              return {
                                ...prev,

                                accNumber: account?.bank_acc_no,
                              };
                            });

                            openTxnPopup(
                              account?.id,
                              account?.name,
                              account?.bank_acc_no,
                            );
                            setAssociateType("rejectAccount");
                          }}
                          ctaBtn1Text={"More details"}
                          ctaBtn1OnClick={
                            account.approval_status === "pending" &&
                            !loading[account.id]
                              ? () => InternalAccountDetailsPopUp(account.id)
                              : undefined
                          }
                          cardState={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            beneInternalWaitingApprovalData &&
                            !loading[account.id]
                              ? "single"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? account.rejection_reason
                                  ? "double"
                                  : "single"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "single"
                                  : "default"
                          }
                          overlay1Text={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            beneInternalWaitingApprovalData &&
                            !loading[account.id]
                              ? "Approved"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "Rejected"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "Failed to take action!"
                                  : undefined
                          }
                          overlay1Subtext={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            beneInternalWaitingApprovalData &&
                            !loading[account.id]
                              ? "This account has been approved."
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "This account has been rejected."
                                : account.error === "true" &&
                                    !loading[account.id]
                                  ? account.message ||
                                    "An error occurred while taking action on this account."
                                  : undefined
                          }
                          overlay1Icon={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            beneInternalWaitingApprovalData &&
                            !loading[account.id]
                              ? "https://q2pay.in/new_assets/common/approval/approved_linear_green.svg"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "https://q2pay.in/new_assets/common/approval/rejected_red.svg"
                                : account.error === "true" &&
                                    !loading[account.id]
                                  ? "https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
                                  : undefined
                          }
                          overlay1CtaText={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              beneInternalWaitingApprovalData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? "View account"
                              : undefined
                          }
                          overlay1CtaOnClick={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              beneInternalWaitingApprovalData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? () => InternalAccountDetailsPopUp(account.id)
                              : undefined
                          }
                          overlay1CtaInactive={false}
                          overlay1CtaDisabled={loading[account.id]}
                          overlay1CtaLoading={loading[account.id]}
                          overlay2Text={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? account.rejection_reason
                              : undefined
                          }
                          overlay2Subtext={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? "Rejected reason"
                              : undefined
                          }
                          alerts={buildAlerts()}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : noTransactionsFromAPI ? (
            <div className="InternalAccount_NoAccountFound gap-gap-sm">
              <div className="w-width-lg">
                <img
                  src={ICONS?.NO_PENDING_TRANSACTION}
                  alt=""
                />
              </div>
              <div className="internal-acc-req-approval-no-data-text">
                <span>There are no more accounts that require</span>
                <span>your approval.</span>
              </div>
              <PrimaryButton
                enabledBgColor="var(--primary-nav-act)"
                btnText="Internal account dashboard"
                btnType="button"
                handleFunction={() => {
                  navigate("/internal_account_dashboard");
                }}
                enabledTextColor="var(--text-primary)"
              />
            </div>
          ) : (
            ""
          )}
          <div
            className={`${allAccounts?.length === GlobalConfiguration.lengthCheckZero ? "hidden" : "block"} ${isSidebarOpen && " hidden lg:block"} w-full z-z-index-fixed-ui`}
          >
            <div
              className={`${(isSidebarOpen || showInnerSearchBar) && "  pointer-events-none"}`}
            >
              <PaginationComponent
                handleSelect={handleSelect}
                selectedValue={selectedValue}
                data={mainData}
                pageSize={pageSize}
                dropdownOptions={dropdownOptions}
                handlePagination={handlePagination}
                currentPage={page}
                setIsOpen={setIsOpen}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InternalAccountApproval;
